var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.4vw",
    height: "1.4vw",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#262626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13H11.5C12.5 13 13 12.5 13 11.5V10.5C13 9.5 12.5 9 11.5 9H10.5C9.5 9 9 9.5 9 10.5V11.5C9 12.5 9.5 13 10.5 13Z",
    stroke: "#50C878",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13H17.5C18.5 13 19 12.5 19 11.5V10.5C19 9.5 18.5 9 17.5 9H16.5C15.5 9 15 9.5 15 10.5V11.5C15 12.5 15.5 13 16.5 13Z",
    stroke: "#50C878",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 19H17.5C18.5 19 19 18.5 19 17.5V16.5C19 15.5 18.5 15 17.5 15H16.5C15.5 15 15 15.5 15 16.5V17.5C15 18.5 15.5 19 16.5 19Z",
    stroke: "#50C878",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 19H11.5C12.5 19 13 18.5 13 17.5V16.5C13 15.5 12.5 15 11.5 15H10.5C9.5 15 9 15.5 9 16.5V17.5C9 18.5 9.5 19 10.5 19Z",
    stroke: "#50C878",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat);
export default __webpack_public_path__ + "static/media/cat.8f6295cc5d4acb7f817837d5a0c7a77b.svg";
export { ForwardRef as ReactComponent };